// The signed-in person (GET /me): user, role, permissions and the applied content-pack version.
// The authed layout loads it before any page renders, so pages read it without a spinner.
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import type { Me } from '@cis/api-client';
import { api } from './client.ts';

const ME_STALE_MS = 60_000;

export const ME_QUERY_KEY = ['me'] as const;

export const meQueryOptions = queryOptions({
  queryKey: ME_QUERY_KEY,
  queryFn: ({ signal }) => api.me.get(signal),
  staleTime: ME_STALE_MS,
});

export function useMe(): Me {
  return useSuspenseQuery(meQueryOptions).data;
}
